import {CDR_DIALER as PREFIX} from '../../const';
import {generateId} from '../../utils';
import {DEFAULT_PER_PAGE_DIALER} from '../../const';

const initialState = {
    loading: false,
    cdr_list: [],
    more: false,
    count: 0,
    page: 1,
    per_page: DEFAULT_PER_PAGE_DIALER,
    summaries: {},
};


const handlers = {
    ['SET_ITEMS_' + PREFIX]: (state, {payload: {cdr_full_list, cdr_full_count, cdr_full_summaries, cdr_full_more, page, per_page}}) => ({
        ...state,
        cdr_list: [
            ...cdr_full_list.map(x => {
                x.id = generateId();
                return x;
            })
        ],
        loading: false,
        count: cdr_full_count,
        summaries: {
           ...cdr_full_summaries
        },
        more: cdr_full_more,
        page,
        per_page
    }),
    ['SET_LOADING_' + PREFIX]: (state, {payload}) => ({...state, loading: payload}),
    DEFAULT: state => state
};

export default (state = initialState, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT;
    return handle(state, action);
};
